import { RegularReportHistoryDetailPage } from "@/features/regular-document/pages/RegularHistoryDetail";

const RegularHistoryDetail = () => {
  return <RegularReportHistoryDetailPage />;
};

export default RegularHistoryDetail;
